import { createContext, useContext } from "react";

/**
 * Dialog Save buttons are wrapped in a DialogClose, which unmounts the dialog on click - before the
 * browser submits the form, so nothing is saved and any validation error is never shown.
 * A host that closes its own dialog from the form's onSuccess provides `true` here, and Save then
 * only submits.
 */
export const KeepDialogOpenOnSaveContext = createContext(false);

export const useKeepDialogOpenOnSave = () => useContext(KeepDialogOpenOnSaveContext);
